"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./SliderWithInput.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderWithInput = function SliderWithInput(_ref) {
  var inputValue = _ref.inputValue,
      handleInputValue = _ref.handleInputValue,
      sliderMin = _ref.sliderMin,
      sliderMax = _ref.sliderMax,
      inputNumberMin = _ref.inputNumberMin,
      inputNumberMax = _ref.inputNumberMax,
      sliderLeftText = _ref.sliderLeftText,
      sliderRightText = _ref.sliderRightText;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "integerSlider-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "integerSlider-slider"
  }, /*#__PURE__*/_react.default.createElement(_antd.Slider, {
    min: sliderMin,
    max: sliderMax,
    onChange: handleInputValue,
    value: typeof inputValue === 'number' ? inputValue : 0
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "integerSlider-monthTextwrap"
  }, /*#__PURE__*/_react.default.createElement("div", null, sliderLeftText), /*#__PURE__*/_react.default.createElement("div", null, sliderRightText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "integerSlider-input"
  }, /*#__PURE__*/_react.default.createElement(_antd.InputNumber, {
    min: inputNumberMin,
    max: inputNumberMax,
    style: {
      margin: '0 16px'
    },
    value: inputValue,
    onChange: handleInputValue
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "integerSlider-mosText"
  }, "mos")));
};

var _default = SliderWithInput;
exports.default = _default;